export const CLASSROOM_DATA_TOPIC = "classnx-classroom-events";

const encoder = new TextEncoder();
const decoder = new TextDecoder();

export function encodeClassroomEvent(event) {
  return encoder.encode(JSON.stringify({
    id: event.id || `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    sentAt: event.sentAt || new Date().toISOString(),
    ...event,
  }));
}

export function decodeClassroomEvent(payload) {
  try {
    const value = JSON.parse(decoder.decode(payload));
    if (!value || !["CHAT", "HAND"].includes(value.type)) return null;
    return value;
  } catch {
    return null;
  }
}

